import { postApi } from '../../../utils/api'

export function shareFilterStates({ bodyData, entity, objectId, sub }) {
  return postApi({
    data: bodyData,
    endpoint: `/idwell-api/api/v3/table/shared-filter-states/${entity.plural}/${sub}/`,
    params: {
      object_id: objectId,
    },
  })
}
